import {useLiveQuery} from 'dexie-react-hooks';
import {getActiveSession} from 'src/offline/offlineSessionManager';
import {EMPTY_PENDING_ITEMS} from 'src/offline/pendingUploads';
import type {
  FailedOutboxItem,
  PendingOutboxItems,
} from 'src/offline/pendingUploads';
import {formSubmissionCascade} from './outboxActions';
import {FORMS_CONTEXT_KEY} from './snapshotKeys';

export type FailedFormSubmission = FailedOutboxItem;
export type PendingFormSubmissions = PendingOutboxItems;

/** Live view of the form-create outbox for the owned forms session. */
export const usePendingFormSubmissions = (): PendingFormSubmissions =>
  useLiveQuery(async () => {
    const session = await getActiveSession(FORMS_CONTEXT_KEY);
    if (!session) return EMPTY_PENDING_ITEMS;
    return formSubmissionCascade.pendingItems(session.id);
  }, []) ?? EMPTY_PENDING_ITEMS;
